import { getCurrentLanguage } from 'src/utils/BasePathTools';
import { UAParser } from 'ua-parser-js';
import type { DeviceData, HostData } from '../types';

const COLOR_SCHEME = { DARK: 'dark', LIGHT: 'light', NA: 'n/a' } as const;

function getDeviceInfo(): DeviceData {
	const parser = new UAParser();
	const { os, device } = parser.getResult();
	const type = /Mobi|Android|iPhone|iPad/i.test(navigator.userAgent) ? 'mobile' : 'desktop';
	return {
		os: os.name,
		osVersion: os.version,
		deviceModel: device.model,
		type,
		colorScheme: COLOR_SCHEME.LIGHT,
		firebaseId: '',
	};
}

export interface IDeviceProvider {
	getDeviceData(): DeviceData & { language?: string };
}

class NonEmbeddedDeviceProvider implements IDeviceProvider {
	getDeviceData(): DeviceData & { language?: string } {
		const { type, os, osVersion, deviceModel: name } = getDeviceInfo();
		return {
			type,
			os,
			osVersion,
			name,
			language: !!getCurrentLanguage() ? `${getCurrentLanguage()?.toLowerCase()}_${getCurrentLanguage()?.toUpperCase()}` : "",
			colorScheme: COLOR_SCHEME.LIGHT,
			firebaseId: '',
		};
	}
}

export function getDeviceProvider(): IDeviceProvider {
	return new NonEmbeddedDeviceProvider();
}

export function getHostData(): HostData {
	const appVersion = "1.101.0";

	const ua = navigator.userAgent.toLowerCase();
	let platform = 'web';
	if (/iphone|ipad|ipod/.test(ua)) platform = 'ios';
	else if (/android/.test(ua)) platform = 'android';

	return { platform, appVersion, isEmbedded: false };
}
